import { Layer, LayerProps } from 'shared/map-exports';
import { useMapLayersState } from 'state/useMapLayersState';
import { useReporterCoverageDebugState } from 'state/useReporterCoverageDebugState';
import { getWatchdutyStaticTileUrl } from 'features/mapping/components/layers/layers.utils';
import { useStaticTileCacheDomain } from 'features/mapping/hooks/useStaticTileCacheDomain';
import { addVisible } from 'shared/addVisible';
import { MapLayerProps } from 'features/mapping/mapping.types';
import { ON_TOP_OF_EVERYTHING_LAYER_ID } from 'features/mapping/styles';
import { useReporterCoverageCommandPaletteAction } from 'hooks/commandPaletteActions';
import { VisibilityToggledSource } from '../VisibilityToggledSource';

const noCoverageFillStyle = (isDark: boolean): LayerProps => ({
  id: 'reporter-no-coverage-fill',
  type: 'fill',
  'source-layer': 'no_coverage',
  paint: {
    'fill-pattern': isDark
      ? 'DiagonalHatchPatternWhite'
      : 'DiagonalHatchPatternBlack',
    'fill-opacity': isDark ? 0.35 : 0.2,
  },
});

const coverageStrokeStyle = (
  sourceLayer: string,
  isDark: boolean,
): LayerProps => ({
  id: `reporter-${sourceLayer}-stroke`,
  type: 'line',
  'source-layer': sourceLayer,
  paint: {
    'line-color': isDark ? '#FFFFFF' : '#444444',
    'line-opacity': 0.2,
    'line-width': 1,
  },
});

export const ReporterCoverageLayer = ({
  visible,
}: MapLayerProps): JSX.Element => {
  const { isDarkBaseLayer } = useMapLayersState();
  const { isHidden } = useReporterCoverageDebugState();
  const staticTileCacheDomain = useStaticTileCacheDomain();
  useReporterCoverageCommandPaletteAction();

  const isVisible = visible && !isHidden;

  return (
    <VisibilityToggledSource
      url={getWatchdutyStaticTileUrl('region_coverage', staticTileCacheDomain)}
      visible={isVisible}
    >
      <Layer
        beforeId={ON_TOP_OF_EVERYTHING_LAYER_ID}
        {...addVisible(noCoverageFillStyle(isDarkBaseLayer), isVisible)}
      />
      <Layer
        beforeId={ON_TOP_OF_EVERYTHING_LAYER_ID}
        {...addVisible(
          coverageStrokeStyle('no_coverage', isDarkBaseLayer),
          isVisible,
        )}
      />
    </VisibilityToggledSource>
  );
};
